module.exports = __webpack_public_path__ + "img/关于宏邦2.2200fac6.jpg";